<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-20">
            My Success Roadmap
        </div>
        <div class="content card round-medium" :style="loadBg">
            <div class="top-bar" :style="loadBar"></div>

            <!-- PDF Viewer Modal -->
            <PdfViewer 
                v-if="showPdfViewer"
                :pdfUrl="currentPdfUrl"
                :title="currentPdfTitle"
                @close="closePdfViewer"
            />

            <!-- mobile -->
            <div class="mobile-display">
                <carousel :autoplay="false" :nav="true" :items="1" :margin="20" :dots="false" :stagePadding="15"
                    :navText="['<', '>']" :touchDrag="false" :mouseDrag="false" :pullDrag="false" :freeDrag="false">
                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'"
                                        class="responsive-image roadmap-back-img" />
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                Training Support for Success
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="responsive-iframe"
                            style="padding-bottom: 0px; height: 500px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 8px; border: 1px solid #e0e0e0;">
                            <video width="90%" height="90%" controls onloadedmetadata="this.muted = true" playsinline
                                autoplay muted loop style="border-radius: 8px;">
                                <source :src="'images/mpower-new/my_success_roadmap/development/video/delevopment.mp4'"
                                    type="video/mp4">
                            </video>
                        </div>
                    </div>

                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'"
                                        class="responsive-image roadmap-back-img" />
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 GBA Training Roadmap
                            </div>
                            <div class="clear"></div>

                            <!-- <div class="image-container-full">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/01.png'"
                                    alt="Training Roadmap">
                            </div> -->

                            <div style="height: 50dvh;width: 100%;overflow: auto;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/01b.png'"
                                    style="display: block; height: 100%; width: auto; max-width: none;" alt="Training Roadmap">
                            </div>

                            <div class="swipe-instruction">
                                Swipe to view brochure
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'"
                                        class="responsive-image roadmap-back-img" />
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 GBA Training Roadmap
                            </div>
                            <div class="clear"></div>

                            <!-- <div class="image-container-full">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/02.png'"
                                    class="full-height-image" alt="Training Roadmap">
                            </div> -->

                             <div style="height: 50dvh;width: 100%;overflow: auto;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/02.png'"
                                    style="display: block; height: 100%; width: auto; max-width: none;" alt="Training Roadmap">
                            </div>

                            <div class="swipe-instruction">
                                Swipe to view brochure
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'"
                                        class="responsive-image roadmap-back-img" />
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 GBA Training Roadmap
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="image-container-full">
                            <a @click.prevent="openPdfViewer('images/mpower-new/my_success_roadmap/development/pdf/Generali Training Road Map 2026.pdf', '2026 GBA Training Roadmap')"
                                class="d-inline-block"
                                style="height: 100%; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/03b.png'"
                                    class="responsive-image"
                                    style="max-height: 90%; max-width: 90%; object-fit: contain;">
                            </a>
                        </div>

                    </div>

                   
                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'"
                                        class="responsive-image roadmap-back-img" />
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 Full GBA Training Roadmap
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="image-container-full">
                            <a @click.prevent="openPdfViewer('images/mpower-new/my_success_roadmap/development/pdf/Generali Full Training Road Map 2026.pdf', '2026 GBA Full Training Roadmap')"
                                class="d-inline-block"
                                style="height: 100%; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/04.png'"
                                    class="responsive-image"
                                    style="max-height: 90%; max-width: 90%; object-fit: contain;">
                            </a>
                        </div>
                    </div>
                </carousel>
            </div>

            <!-- ipad -->
            <div class="ipad-display">
                <carousel :autoplay="false" :nav="true" :items="1" :margin="20" :dots="false" :stagePadding="15"
                    :navText="['<', '>']" :touchDrag="false" :mouseDrag="false" :pullDrag="false" :freeDrag="false">
                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                Training Support for Success
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="responsive-iframe" style="padding-bottom: 0px; height: 500px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 8px; border: 1px solid #e0e0e0;">
                            <video width="90%" height="90%" controls onloadedmetadata="this.muted = true" playsinline autoplay muted loop style="border-radius: 8px;">
                                <source :src="'images/mpower-new/my_success_roadmap/development/video/delevopment.mp4'" type="video/mp4">
                            </video>
                        </div>
                    </div>

                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'"
                                        class="responsive-image roadmap-back-img" />
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 GBA Training Roadmap
                            </div>
                            <div class="clear"></div>

                            <div style="height: 50dvh;width: 100%;overflow: auto;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/iPad/01a.png'"
                                    style="display: block; height: 100%; width: auto; max-width: none;" alt="Training Roadmap">
                            </div>
                            <div class="swipe-instruction">
                                Swipe to view brochure
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 GBA Training Roadmap
                            </div>
                            <div class="clear"></div>
        
                            <div style="height: 50dvh;width: 100%;overflow: auto;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/iPad/02.png'"
                                    style="display: block; height: 100%; width: auto; max-width: none;" alt="Training Roadmap">
                            </div>
                            <div class="swipe-instruction">
                                Swipe to view brochure
                            </div>
                        </div>
                   </div>

                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 GBA Training Roadmap
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="image-container-full">
                            <a @click.prevent="openPdfViewer('images/mpower-new/my_success_roadmap/development/pdf/Generali Training Road Map 2026.pdf', '2026 GBA Training Roadmap')"
                                class="d-inline-block"
                                style="height: 100%; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/iPad/03a.png'"
                                    class="responsive-image"
                                    style="max-height: 90%; max-width: 90%; object-fit: contain;">
                            </a>
                        </div>
                    </div>

                    <div>
                        <div class="content-title padding-5 margin-top-20">
                            <div class="roadmap-back-wrapper ipad-display">
                                <router-link :to="'success-roadmap'" class="margin-top-0 ">
                                    <img :src="'images/mpower-new/my_success_roadmap/back.png'" class="responsive-image roadmap-back-img"/>
                                </router-link>
                            </div>
                            <div class="roadmap-title-wrapper">
                                2026 GBA Full Training Roadmap
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="image-container-full">
                            <a @click.prevent="openPdfViewer('images/mpower-new/my_success_roadmap/development/pdf/Generali Full Training Road Map 2026.pdf', '2026 GBA Full Training Roadmap')"
                                class="d-inline-block"
                                style="height: 100%; display: flex; align-items: center; justify-content: center; cursor: pointer;">
                                <img :src="'images/mpower-new/my_success_roadmap/brochure/iPad/04.png'"
                                    class="responsive-image"
                                    style="max-height: 90%; max-width: 90%; object-fit: contain;">
                            </a>
                        </div>
                    </div>
                </carousel>
            </div>
        </div>
        <RoadmapNav />
    </div>
</template>
<style scoped>
.mobile-display .mandatory {
    text-align: left;
    padding-left: 10px;
    color: #6b867f;
}

.ipad-display .mandatory {
    text-align: left;
    padding-left: 10px;
    color: #6b867f;
}

.mobile-display .notes {
    text-align: left;
    font-size: 11px;
    font-style: italic;
    line-height: 1.5;
    padding-left: 10px;
    color: #FF4500;
}

.ipad-display .notes {
    text-align: left;
    font-size: 11px;
    font-style: italic;
    line-height: 1.5;
    padding-left: 10px;
    color: #FF4500;
}

.image-container-full {
    width: 100%;
    height: 500px;
    overflow-x: auto;
    overflow-y: hidden;
    background: white;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    touch-action: pan-x;
    -webkit-overflow-scrolling: touch;
}

.full-height-image {
    height: 100%;
    width: auto;
    display: block;
    min-width: 250%;
    object-fit: cover;
    object-position: left center;
}

.swipe-instruction {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #333;
    margin-top: 15px;
    margin-bottom: 10px;
}
</style>
<script>
import RoadmapNav from '@/components/RoadmapNav.vue'
import PdfViewer from '@/components/PdfViewer.vue'
import carousel from 'vue-owl-carousel'
export default {
    name: 'Agent_journey',
    data() {
        return {
            showPdfViewer: false,
            currentPdfUrl: '',
            currentPdfTitle: ''
        }
    },
    computed: {
        loadBg() {
            return {
                'backgroundImage': 'url(\'images/mpower/roadmap/blank_bg.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        },
        loadBar() {
            return {
                'background': '#AFC8B4'
            }
        }
    },
    components: {
        RoadmapNav, PdfViewer, carousel
    },
    methods: {
        openPdfViewer(pdfUrl, title) {
            this.currentPdfUrl = pdfUrl
            this.currentPdfTitle = title
            this.showPdfViewer = true
        },
        closePdfViewer() {
            this.showPdfViewer = false
            this.currentPdfUrl = ''
            this.currentPdfTitle = ''
        }
    },
    mounted() {
        window.scrollTo(0, 0);
    }
}
</script>
